import { render, staticRenderFns } from "./AtomFacts.vue?vue&type=template&id=3012c430&"
import script from "./AtomFacts.vue?vue&type=script&lang=js&"
export * from "./AtomFacts.vue?vue&type=script&lang=js&"
import style0 from "./AtomFacts.vue?vue&type=style&index=0&id=3012c430&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports